import { Col, Row } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { Button, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { ColDef } from "ag-grid-enterprise";
import { useNavigate } from "react-router-dom";
import { GetTemplateMappings } from "../../api/emailTemplateMappingApi/emailTemplateMappingApi";
import { useSnackbar } from "../Common/SnackbarContext";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import LocalStorageUtil from "../../utils/localStorage";

const EmailTemplateMapping = () => {
  const { showSnackbar } = useSnackbar();
  const [rowData, setRowData] = useState<any[]>([]);
  const { setLoading } = useLoader();
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const gridRef = useRef<AgGridReact>(null);
  const navigation = useNavigate();
  useEffect(() => {
    getData();
  }, []);
  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    enableRowGroup: true,
  };
  const getData = async () => {
    setLoading(true);
    const payload: any = {
      accountId: Number(LocalStorageUtil.getItem("accountId")),
      searchText: "",
      contextName: LocalStorageUtil.getItem("contextName"),
      currentPage: 1,
      noOfRecords: 0,
      sortColumn: "",
      sortOrder: 0,
    };
    try {
      const userData = await GetTemplateMappings(payload);
      setRowData(
        userData.listEmailTemplateModel.sort(
          (a: any, b: any) =>
            a.emailTemplateMappingId - b.emailTemplateMappingId
        )
      );
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  };

  const actionCellRenderer = (props: any) => {
    if (props.data === undefined) {
      return "";
    } else {
      const handleEditAction = () => {
        const selectedRowData = props.data;
        navigation("/emailtemplatemappingcreate", {
          state: { rowData: selectedRowData, action: "Edit" },
        });
      };
      return (
        <Tooltip title="Click To Edit Email Template Mapping">
          <a style={{ color: "var(--aggrid-text-color)" }}>
            <EditIcon
              className="icon-button-other"
              onClick={handleEditAction}
            />
          </a>
        </Tooltip>
      );
    }
  };

  const [columnDefs] = useState<ColDef[]>([
    {
      headerName: "#",
      field: "emailTemplateMappingId",
      tooltipField: "templateName",
      width: 70,
      colId: "templateName",
      sortable: true,
    },
    {
      headerName: "Email Template Name",
      field: "emailTemplateTypeName",
      tooltipField: "templateName",
      width: 400,
      colId: "templateName",
    },
    {
      headerName: "Email Template Group Name",
      field: "emailTemplateGroupName",
      tooltipField: "emailTemplateGroupName",
      width: 400,
      colId: "emailTemplateGroupName",
    },
    {
      headerName: "Field",
      field: "metadataFieldName",
      tooltipField: "Field",
      width: 400,
      colId: "description",
      flex: 1,
    },
    {
      headerName: "Value",
      field: "value",
      tooltipField: "Value",
      width: 200,
      colId: "description",
      flex: 1,
    },
    {
      headerName: "Actions",
      field: "link",
      cellRenderer: actionCellRenderer,
      lockPinned: true,
      suppressSizeToFit: true,
      width: 100,
      minWidth: 100,
      pinned: "right",
      sortable: false,
      filter: false,
      resizable: false,
      enableRowGroup: false,
    },
  ]);

  //Quick Filter
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current!.api.setGridOption(
      "quickFilterText",
      (document.getElementById("filter-text-box") as HTMLInputElement).value
    );
  }, []);

  const handelCreateNew = () => {
    navigation("/emailtemplatemappingcreate");
  };

  return (
    <div style={{overflow: "hidden"}}>
      <NavigationBar
        menuTitle="Configuration"
        title="Email Template Mapping"
        text="Email Template Mapping"
      />
      <Row style={{ marginLeft: "1em" }}>
        <Col xs={12}>
          <div
            className="rp-main-inner col-sm-12"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {/* Quick Filter section */}

            <div
              className="col-sm-5"
              style={{
                width: "48%",
                padding: ".5em",
                marginTop: ".1em",
              }}
            >
              <input
                type="text"
                id="filter-text-box"
                placeholder="Quick Filter..."
                style={{
                  width: "25em",
                  height: "2.5em",
                  fontSize: "11px",
                  paddingLeft: ".5em",
                  marginBottom: ".1em",
                }}
                onInput={onFilterTextBoxChanged}
              />
            </div>
            <div
              className="col-sm-5"
              style={{
                textAlign: "right",
                margin: "10px",
              }}
            >
              <Button
                variant="contained"
                className="button createnew-button"
                onClick={handelCreateNew}
              >
                Create new
              </Button>
            </div>
          </div>
          <div className="rp-main-inner col-sm-12">
            {/* Ag-Grid Section */}
            <div className="rp-main-inner col-sm-12">
              <div
                className="ag-theme-quartz-dark"
                style={{
                  height: "66vh",
                  marginTop: ".1vh",
                  width: "99%",
                }}
              >
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={rowData}
                  pagination={true}
                  paginationPageSize={defaulPageSize}
                  paginationPageSizeSelector={pageSizeSelector}
                  rowGroupPanelShow="always"
                  pivotPanelShow="always"
                  ref={gridRef}
                  headerHeight={30}
                  defaultColDef={defaultColDef}
                  loading={!rowData}
                  overlayNoRowsTemplate={
                    '<span class="ag-overlay-loading-center">No rows to show</span>'
                  }
                  loadingOverlayComponent={CustomLoadingOverlay}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EmailTemplateMapping;
